import type { IFilter } from '@models/Filter'
import type { Query } from '@models/Query'

import { apiClient } from '../../../gateways/api'
import type {
  FetchWerkbakken,
  FetchWerkbakkenFilters,
} from '../types/FetchWerkbakken'

export { fetchWerkbakken, createFilters, initialState }

const fetchWerkbakken = async ({
  query,
}: {
  query: Query<FetchWerkbakkenFilters>
}): Promise<FetchWerkbakken['data']> => {
  const { filters } = query

  const { data } = await apiClient({
    url: '/rest/opdracht/deelnemer/werkbakken',
    method: 'POST',
    data: { filters: createFilters(filters) },
  })

  return data
}

const createFilters = ({ netbeheerder, aannemer, gebied }) => {
  const filters: IFilter[] = []

  if (netbeheerder)
    filters.push({ name: 'netbeheerder', value: netbeheerder, operator: 'eq' })
  if (aannemer)
    filters.push({ name: 'aannemer', value: aannemer, operator: 'eq' })
  if (gebied && gebied.length > 0)
    filters.push({
      name: 'details.combi.gebiedscode',
      value: gebied.map((x) => x.code),
      operator: 'in',
    })

  return filters
}

const initialState: FetchWerkbakken = {
  data: [],
  query: {
    filters: {
      netbeheerder: null,
      aannemer: null,
      gebied: [],
    },
  },
}
